export default "__VITE_ASSET__BeJQiL3f__"